"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.rejectPurchaseOrderSchema = exports.updatePurchaseOrderSchema = exports.createPurchaseOrderSchema = exports.purchaseOrderShape = exports.purchaseOrderLineSchema = exports.purchaseOrderLineShape = void 0;
const zod_1 = require("zod");
exports.purchaseOrderLineShape = {
    drugId: zod_1.z.string().uuid().optional(),
    itemId: zod_1.z.string().uuid().optional(),
    orderedQuantity: zod_1.z.number().positive(),
    /** Omitted => an "open" line, price to be negotiated/confirmed later — never fabricated as a real ₹0 (free) price. */
    unitPrice: zod_1.z.number().int().nonnegative().optional(),
    sortOrder: zod_1.z.number().int().nonnegative(),
};
exports.purchaseOrderLineSchema = zod_1.z.object(exports.purchaseOrderLineShape);
exports.purchaseOrderShape = {
    branchId: zod_1.z.string().uuid(),
    hospitalId: zod_1.z.string().uuid().optional(),
    vendorId: zod_1.z.string().uuid(),
    poDate: zod_1.z.coerce.date(),
    expectedDeliveryDate: zod_1.z.coerce.date().optional(),
    deliveryLocationId: zod_1.z.string().uuid().optional(),
    paymentTermsDays: zod_1.z.number().int().positive().optional(),
    deliveryTerms: zod_1.z.string().optional(),
    freightTerms: zod_1.z.string().optional(),
    remarks: zod_1.z.string().optional(),
};
exports.createPurchaseOrderSchema = zod_1.z.object({
    ...exports.purchaseOrderShape,
    lines: zod_1.z.array(exports.purchaseOrderLineSchema).min(1),
});
exports.updatePurchaseOrderSchema = zod_1.z.object(exports.purchaseOrderShape).partial();
exports.rejectPurchaseOrderSchema = zod_1.z.object({ reason: zod_1.z.string().min(1) });
//# sourceMappingURL=purchase-order.schema.js.map